// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change Topic — matches src/!design/design.html */

.ctview {
  flex: 1 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--bg, #F1F5F9);
  color: var(--ink, #15212B);
}

.ctview .vhead {
  flex: none;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 26px 30px 18px;
}

.ctview .vhead__titles {
  min-width: 0;
}

.ctview .vhead__title {
  font-size: 25px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.02em;
  color: var(--ink, #15212B);
}

.ctview .vhead__sub {
  margin: 3px 0 0;
  font-size: 14px;
  color: var(--muted, #5C6E7D);
}

.ctscroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 30px 8px;
}

.ctwrap {
  max-width: 880px;
}

.ctwrap__search {
  max-width: none;
  margin-bottom: 18px;
}

.ctview .lsearch {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 40px;
  padding: 0 13px;
  background: var(--surface, #fff);
  border: 1px solid var(--line, #E4EAF0);
  border-radius: 10px;
  color: var(--muted-2, #8395A3);
  transition: border-color 0.13s;
}

.ctview .lsearch--sm {
  height: 38px;
}

.ctview .lsearch:focus-within {
  border-color: var(--blue-200, #B7D3EA);
}

.ctview .lsearch svg {
  flex: none;
}

.ctview .lsearch input {
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  color: var(--ink, #15212B);
  width: 100%;
}

.ctview .lsearch input::placeholder {
  color: var(--muted-2, #8395A3);
}

.cthead {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 16px 9px;
}

.cthead__topic {
  flex: 1 1;
}

.cthead__topic,
.cthead__active,
.cthead__sub {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--muted-2, #8395A3);
}

.cthead__ctrls {
  display: flex;
  align-items: center;
  gap: 18px;
}

.cthead__active {
  width: 54px;
  text-align: center;
}

.cthead__sub {
  width: 140px;
}

.ctcards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ctcard {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 11px 16px;
  border: 1px solid var(--line, #E4EAF0);
  border-radius: 12px;
  background: var(--surface, #fff);
  transition: border-color 0.12s, background 0.12s, box-shadow 0.12s;
}

.ctcard--sel {
  border-color: var(--blue-500, #2E86CE);
  background: var(--blue-50, #EAF2F9);
  box-shadow: 0 0 0 1px var(--blue-500, #2E86CE);
}

.ctcard--unsub {
  background: var(--line-soft, #EFF3F7);
  border-color: transparent;
}

.ctcode {
  width: 38px;
  height: 38px;
  flex: none;
  border-radius: 9px;
  background: var(--blue-50, #EAF2F9);
  color: var(--blue-700, #155489);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  font-weight: 600;
}

.ctcard--unsub .ctcode {
  background: #fff;
  color: var(--muted-2, #8395A3);
}

.ctcard__main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
  padding: 0;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.ctcard__main:disabled {
  cursor: default;
}

.ctcard__name {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ink, #15212B);
}

.ctcard--unsub .ctcard__name {
  color: var(--muted, #5C6E7D);
}

.ctcard__badge {
  flex: none;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--green, #1F8A5B);
  background: var(--green-bg, #E6F4EC);
  padding: 2px 8px;
  border-radius: 999px;
}

.ctctrls {
  display: flex;
  align-items: center;
  gap: 18px;
}

.ctsel {
  width: 54px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.ctsel:disabled {
  cursor: default;
}

.ctsel__ring {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--line, #E4EAF0);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.12s;
}

.ctsel--on .ctsel__ring {
  border-color: var(--blue-600, #1C6BB0);
}

.ctsel__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--blue-600, #1C6BB0);
}

.ctsub {
  width: 140px;
  flex: none;
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 500;
  color: var(--muted-2, #8395A3);
}

.ctsub svg {
  flex: none;
}

.ctsub--on {
  color: var(--green, #1F8A5B);
}

.cttip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 18px 0 6px;
  padding: 13px 15px;
  background: var(--blue-50, #EAF2F9);
  border-radius: 11px;
  color: var(--blue-800, #0F3F66);
  font-size: 12.5px;
  line-height: 1.5;
}

.cttip svg {
  flex: none;
  margin-top: 1px;
  color: var(--blue-600, #1C6BB0);
}

.ctbar {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 30px;
  border-top: 1px solid var(--line, #E4EAF0);
  background: var(--surface, #fff);
}

.ctbar__status {
  font-size: 13.5px;
  color: var(--muted, #5C6E7D);
}

.ctbar__status b {
  color: var(--ink, #15212B);
  font-weight: 600;
}

.ctview .ebtn {
  height: 44px;
  padding: 0 18px;
  border-radius: 11px;
  border: 1px solid var(--line, #E4EAF0);
  background: var(--surface, #fff);
  color: var(--ink, #15212B);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.13s;
}

.ctview .ebtn--primary {
  background: var(--blue-600, #1C6BB0);
  border-color: var(--blue-600, #1C6BB0);
  color: #fff;
  box-shadow: 0 2px 8px rgba(28, 107, 176, 0.28);
}

.ctview .ebtn--primary:hover:not(:disabled) {
  background: var(--blue-700, #155489);
}

.ctview .ebtn--primary:disabled {
  opacity: 1;
  color: #fff;
  background: var(--blue-200, #B7D3EA);
  border-color: var(--blue-200, #B7D3EA);
  box-shadow: none;
  cursor: default;
}

.ctempty {
  padding: 40px 16px;
  text-align: center;
  color: var(--muted-2, #8395A3);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/Topics/ChangeTopic.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;EAChC,kEAAkE;AACpE;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;EAChC,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":["/* Change Topic — matches src/!design/design.html */\r\n\r\n.ctview {\r\n  flex: 1;\r\n  min-height: 0;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: var(--bg, #F1F5F9);\r\n  color: var(--ink, #15212B);\r\n}\r\n\r\n.ctview .vhead {\r\n  flex: none;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  padding: 26px 30px 18px;\r\n}\r\n\r\n.ctview .vhead__titles {\r\n  min-width: 0;\r\n}\r\n\r\n.ctview .vhead__title {\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n  letter-spacing: -0.02em;\r\n  color: var(--ink, #15212B);\r\n}\r\n\r\n.ctview .vhead__sub {\r\n  margin: 3px 0 0;\r\n  font-size: 14px;\r\n  color: var(--muted, #5C6E7D);\r\n}\r\n\r\n.ctscroll {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 0 30px 8px;\r\n}\r\n\r\n.ctwrap {\r\n  max-width: 880px;\r\n}\r\n\r\n.ctwrap__search {\r\n  max-width: none;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.ctview .lsearch {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  height: 40px;\r\n  padding: 0 13px;\r\n  background: var(--surface, #fff);\r\n  border: 1px solid var(--line, #E4EAF0);\r\n  border-radius: 10px;\r\n  color: var(--muted-2, #8395A3);\r\n  transition: border-color 0.13s;\r\n}\r\n\r\n.ctview .lsearch--sm {\r\n  height: 38px;\r\n}\r\n\r\n.ctview .lsearch:focus-within {\r\n  border-color: var(--blue-200, #B7D3EA);\r\n}\r\n\r\n.ctview .lsearch svg {\r\n  flex: none;\r\n}\r\n\r\n.ctview .lsearch input {\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  color: var(--ink, #15212B);\r\n  width: 100%;\r\n}\r\n\r\n.ctview .lsearch input::placeholder {\r\n  color: var(--muted-2, #8395A3);\r\n}\r\n\r\n.cthead {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 0 16px 9px;\r\n}\r\n\r\n.cthead__topic {\r\n  flex: 1;\r\n}\r\n\r\n.cthead__topic,\r\n.cthead__active,\r\n.cthead__sub {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.07em;\r\n  text-transform: uppercase;\r\n  color: var(--muted-2, #8395A3);\r\n}\r\n\r\n.cthead__ctrls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n}\r\n\r\n.cthead__active {\r\n  width: 54px;\r\n  text-align: center;\r\n}\r\n\r\n.cthead__sub {\r\n  width: 140px;\r\n}\r\n\r\n.ctcards {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.ctcard {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 11px 16px;\r\n  border: 1px solid var(--line, #E4EAF0);\r\n  border-radius: 12px;\r\n  background: var(--surface, #fff);\r\n  transition: border-color 0.12s, background 0.12s, box-shadow 0.12s;\r\n}\r\n\r\n.ctcard--sel {\r\n  border-color: var(--blue-500, #2E86CE);\r\n  background: var(--blue-50, #EAF2F9);\r\n  box-shadow: 0 0 0 1px var(--blue-500, #2E86CE);\r\n}\r\n\r\n.ctcard--unsub {\r\n  background: var(--line-soft, #EFF3F7);\r\n  border-color: transparent;\r\n}\r\n\r\n.ctcode {\r\n  width: 38px;\r\n  height: 38px;\r\n  flex: none;\r\n  border-radius: 9px;\r\n  background: var(--blue-50, #EAF2F9);\r\n  color: var(--blue-700, #155489);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-family: \"IBM Plex Mono\", monospace;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n}\r\n\r\n.ctcard--unsub .ctcode {\r\n  background: #fff;\r\n  color: var(--muted-2, #8395A3);\r\n}\r\n\r\n.ctcard__main {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 0;\r\n  font-family: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.ctcard__main:disabled {\r\n  cursor: default;\r\n}\r\n\r\n.ctcard__name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  min-width: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: var(--ink, #15212B);\r\n}\r\n\r\n.ctcard--unsub .ctcard__name {\r\n  color: var(--muted, #5C6E7D);\r\n}\r\n\r\n.ctcard__badge {\r\n  flex: none;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n  color: var(--green, #1F8A5B);\r\n  background: var(--green-bg, #E6F4EC);\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n}\r\n\r\n.ctctrls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n}\r\n\r\n.ctsel {\r\n  width: 54px;\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.ctsel:disabled {\r\n  cursor: default;\r\n}\r\n\r\n.ctsel__ring {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  border: 2px solid var(--line, #E4EAF0);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: border-color 0.12s;\r\n}\r\n\r\n.ctsel--on .ctsel__ring {\r\n  border-color: var(--blue-600, #1C6BB0);\r\n}\r\n\r\n.ctsel__dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  background: var(--blue-600, #1C6BB0);\r\n}\r\n\r\n.ctsub {\r\n  width: 140px;\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: var(--muted-2, #8395A3);\r\n}\r\n\r\n.ctsub svg {\r\n  flex: none;\r\n}\r\n\r\n.ctsub--on {\r\n  color: var(--green, #1F8A5B);\r\n}\r\n\r\n.cttip {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  margin: 18px 0 6px;\r\n  padding: 13px 15px;\r\n  background: var(--blue-50, #EAF2F9);\r\n  border-radius: 11px;\r\n  color: var(--blue-800, #0F3F66);\r\n  font-size: 12.5px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.cttip svg {\r\n  flex: none;\r\n  margin-top: 1px;\r\n  color: var(--blue-600, #1C6BB0);\r\n}\r\n\r\n.ctbar {\r\n  flex: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding: 14px 30px;\r\n  border-top: 1px solid var(--line, #E4EAF0);\r\n  background: var(--surface, #fff);\r\n}\r\n\r\n.ctbar__status {\r\n  font-size: 13.5px;\r\n  color: var(--muted, #5C6E7D);\r\n}\r\n\r\n.ctbar__status b {\r\n  color: var(--ink, #15212B);\r\n  font-weight: 600;\r\n}\r\n\r\n.ctview .ebtn {\r\n  height: 44px;\r\n  padding: 0 18px;\r\n  border-radius: 11px;\r\n  border: 1px solid var(--line, #E4EAF0);\r\n  background: var(--surface, #fff);\r\n  color: var(--ink, #15212B);\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  white-space: nowrap;\r\n  transition: all 0.13s;\r\n}\r\n\r\n.ctview .ebtn--primary {\r\n  background: var(--blue-600, #1C6BB0);\r\n  border-color: var(--blue-600, #1C6BB0);\r\n  color: #fff;\r\n  box-shadow: 0 2px 8px rgba(28, 107, 176, 0.28);\r\n}\r\n\r\n.ctview .ebtn--primary:hover:not(:disabled) {\r\n  background: var(--blue-700, #155489);\r\n}\r\n\r\n.ctview .ebtn--primary:disabled {\r\n  opacity: 1;\r\n  color: #fff;\r\n  background: var(--blue-200, #B7D3EA);\r\n  border-color: var(--blue-200, #B7D3EA);\r\n  box-shadow: none;\r\n  cursor: default;\r\n}\r\n\r\n.ctempty {\r\n  padding: 40px 16px;\r\n  text-align: center;\r\n  color: var(--muted-2, #8395A3);\r\n  font-size: 14px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
